"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCompanyRequestSchema = void 0;
const schemas_1 = require("../../../schemas");
exports.UpdateCompanyRequestSchema = schemas_1.CompanyProfileSchema.partial();
